import type { MemberRole } from '~/clientTeamManagement/teamManagementModal/memberRole.type';
import type { Member } from '~/clientTeamManagement/teamManagementModal/teamManagement.types';
import type {
  CurrentClient, GoogleApiOauthStatus, TwoFactorStats,
} from './repository/userData.repository';
import type { UserSettingsState } from './settings/userDataSettings.state';

export type UserDataState = Readonly<{
  '2fa': TwoFactorStats;
  clientId: number | null;
  clientMembers: Member[];
  clientName: string | null;
  clientRole: MemberRole;
  createdAt: string;
  currentClient: CurrentClient | null;
  email: string;
  firstName: string;
  googleApiOauth: GoogleApiOauthStatus | null;
  id: number | null;
  intercomHash: string;
  isLoading: boolean;
  isPublicApiActive: boolean;
  isReady: boolean;
  isSignedIn: boolean;
  lastName: string;
  limits: UserDataLimits;
  previousLogin: Date | null;
  role: Role;
  settings: UserSettingsState | null;
  teamId: number | null;
  usage: UserDataStateUsage;
}>;

export type UserDataStateUsage = Readonly<{
  createdMaps: number;
  directionsApiRequests: number;
  distanceMatrixRequests: number;
  googlePlacesRequests: number;
  publicMapViews: number;
  realGeocodes: number;
  travelTimeGeocoding: number;
  travelTimeRequests: number;
}>;

export type UserDataLimits = Readonly<{
  allowPublicExportAuthorization: boolean;
  cachedGeocodes: number;
  canExportSharedMapsData: boolean;
  directionsApiRequests: number;
  distanceMatrixRequests: number;
  googlePlacesRequests: number;
  mapView: number;
  maps: number;
  markers: number;
  motEnabled: boolean;
  realGeocodes: number;
  travelTimeGeocoding: number;
  travelTimeRequests: number;
  userLimit: number;
  wmsEnabled: boolean;
}>;

export const Roles = {
  SUPERUSER: 'Superuser',
  CLIENT: 'Client',
  NA: 'N/A',
} as const;

export type Role = typeof Roles[keyof typeof Roles];
